export enum AutoEnrollmentTypes {
  defualtProcessType = 0,
  autoEnrollment = 1,
  contractProduct = 2,
  acceptCashbackConditions = 3,
}
